import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextAreaInputField from "../../components/forms/TextAreaInputField";
import FormError from "../../components/forms/FormError";

function stripLineBreaks(val) {
  return val && val.replace(/[\n\r]/g, " ").replace(/(\s+)/g, " ");
}

class CourierDeliveryInstructionsForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Instructions"
              name="instructions"
              component={TextAreaInputField}
              normalize={stripLineBreaks}
              serverError={this.props.errors.instructions}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "CourierDeliveryInstructionsForm"
})(CourierDeliveryInstructionsForm);


export default ReduxForm;